import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useAuthStore } from "../../../../user/store/useAuthStore";
import { enum_api_uri } from "../../utils/enum";
import axios from "axios";
import axiosInstance from "../axiosInstance";

interface PostBranchProductParams {
    branch_product_name: string;
    branch_product_image: File;
}

export const usePostBranchProduct = (successCallback?: () => void) => {
    const accessToken = useAuthStore.getState().accessToken;
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async ({ branch_product_name, branch_product_image }: PostBranchProductParams) => {
            const formData = new FormData();
            formData.append("branch_product_name", branch_product_name);
            formData.append("branch_product_image", branch_product_image);

            const res = await axiosInstance.post(enum_api_uri.post_branch_product, formData, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    "Content-Type": "multipart/form-data",
                },
            });

            return res.data;
        },
        onSuccess: data => {
            queryClient.invalidateQueries({ queryKey: ["getBranchProduct"] });
            successCallback?.();
        },
    });
};
